module.exports = __webpack_public_path__ + "img/arqu-cabc-07.341f8211.jpg";